import { render, staticRenderFns } from "./LegalTradeSet.vue?vue&type=template&id=bfbd4e74&scoped=true&"
import script from "./LegalTradeSet.vue?vue&type=script&lang=js&"
export * from "./LegalTradeSet.vue?vue&type=script&lang=js&"
import style0 from "./LegalTradeSet.vue?vue&type=style&index=0&id=bfbd4e74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbd4e74",
  null
  
)

export default component.exports